export const CONVERSION_TROY_OZ_TO_G = 31.1034768;

export enum CotacaoScopesEnum {
  ComUsuarioCreatedUpdated = 'ComUsuarioCreatedUpdated',
}
